/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useEffect } from 'react';

import { COMMAND_INTELLIGENCE_CONTENT_SELECTOR, getContentPushPaddingStyle } from './drawerLayout';

const CI_CONTENT_PUSH_ATTR = 'data-command-intelligence-content-push';

const CONTENT_PUSH_TRANSITION = 'padding 0.24s cubic-bezier(0.2, 0, 0, 1)';

export const useCommandIntelligenceContentPush = ({ enabled, layoutMode, dockAnchor, drawerSizePx, isOpen }) => {
  useEffect(() => {
    if (!enabled || layoutMode !== 'push' || !isOpen) {
      return undefined;
    }

    const contentEl =
      typeof document !== 'undefined' ? document.querySelector(COMMAND_INTELLIGENCE_CONTENT_SELECTOR) : null;

    if (!contentEl) {
      return undefined;
    }

    const previousStyle = {
      paddingTop: contentEl.style.paddingTop,
      paddingRight: contentEl.style.paddingRight,
      paddingBottom: contentEl.style.paddingBottom,
      paddingLeft: contentEl.style.paddingLeft,
      transition: contentEl.style.transition,
    };

    const paddingStyle = getContentPushPaddingStyle(dockAnchor, drawerSizePx);

    contentEl.style.transition = CONTENT_PUSH_TRANSITION;
    contentEl.style.paddingTop = paddingStyle.paddingTop;
    contentEl.style.paddingRight = paddingStyle.paddingRight;
    contentEl.style.paddingBottom = paddingStyle.paddingBottom;
    contentEl.style.paddingLeft = paddingStyle.paddingLeft;
    contentEl.setAttribute(CI_CONTENT_PUSH_ATTR, dockAnchor);

    return () => {
      contentEl.style.paddingTop = previousStyle.paddingTop;
      contentEl.style.paddingRight = previousStyle.paddingRight;
      contentEl.style.paddingBottom = previousStyle.paddingBottom;
      contentEl.style.paddingLeft = previousStyle.paddingLeft;
      contentEl.style.transition = previousStyle.transition;
      contentEl.removeAttribute(CI_CONTENT_PUSH_ATTR);
    };
  }, [dockAnchor, drawerSizePx, enabled, isOpen, layoutMode]);
};
